import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment-timezone";
import * as Actions from "../redux/action";
import monitor_detail from "../../../icons/montior-details.svg";
import { ReactComponent as MonitorO } from "../../../icons/audioIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../icons/download_audio.svg";
import NewDateRange from "./DateRange";
import { requestAudio, checkStatus } from "./_redux/monitorCrud";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
class AudioFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      monitorDetailsData: null,
      monitorDetailsDataB: null,
      responseMonitorsDetails: false,
      errorMsgMonitorDetails: "",
      monitorDetailsLoading: false,
      audioPause: null,
      requestAudioMsg: null,
      downloadAudioloading: false,
      downloadAudio: false,
      downloadAudioB: false,
      open: false,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props && this.props.monitor !== null) {
      this.setState({
        ...this.state,
        loading: false,
      });
      //this.monitorDetails(this.props.monitor.id);
    }
    if (prevProps !== this.props && this.props.status === false) {
      this.setState({
        ...this.state,
        loading: false,
        error: this.props.error,
      });
    }
  }
  requestAudio() {
    this.setState({
      ...this.state,
      requestAudioMsg: null,
      downloadAudioloading: true,
    });
    requestAudio(this.props.monitor.id)
      .then((res) => {
        if (res.data.status === true && res.data.message === "success") {
          this.channelRequestCheck(this.props.monitor.id);
        } else {
          this.setState({
            ...this.state,
            requestAudioMsg: res.data.message,
            downloadAudioloading: false,
            open: true,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              requestAudioMsg: error.response.data.message,
              downloadAudioloading: false,
              open: true,
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            requestAudioMsg: error.message,
            downloadAudioloading: false,
            open: true,
          });
        }
      });
  }
  timerAudio;
  channelRequestCheck(id) {
    let check = true;
    if (check === true) {
      this.timerAudio = setInterval(() => {
        checkStatus(id)
          .then((res) => {
            if (res.data.status === true) {
              let data = res.data.data;
              if (
                data[0].probe_status === "A" &&
                data[0].channel_a === "COMPLETED"
              ) {
                clearInterval(this.timerAudio);
                this.props.handleAudioGrid(true);
                this.setState({
                  downloadAudioloading: false,
                });
              } else if (
                data[0].probe_status === "B" &&
                data[0].channel_b === "COMPLETED"
              ) {
                clearInterval(this.timerAudio);
                this.props.handleAudioGrid(true);
                this.setState({
                  downloadAudioloading: false,
                });
              } else if (
                data[0].probe_status === "AB" &&
                data[0].channel_a === "COMPLETED" &&
                data[0].channel_b === "COMPLETED"
              ) {
                clearInterval(this.timerAudio);
                this.props.handleAudioGrid(true);
                this.setState({
                  downloadAudioloading: false,
                });
              }
            } else {
              clearInterval(this.timerAudio);
              this.setState({
                ...this.state,
                downloadAudioloading: false,
                requestAudioMsg: res.data.message,
                open: true,
              });
            }
          })
          .catch((error) => {
            clearInterval(this.timerAudio);
            if (error.response) {
              if (error.response.status !== 404 && error) {
                this.setState({
                  ...this.state,
                  requestAudioMsg: error.response.data.message,
                  downloadAudioloading: false,
                  open: true,
                });
              } else {
                this.props.history.push("error/error-v1");
              }
            } else {
              this.setState({
                ...this.state,
                requestAudioMsg: error.message,
                downloadAudioloading: false,
                open: true,
              });
            }
          });
      }, 6000);
    }
  }
  handleClose = () => this.setState({ open: false });
  render() {
    const { open } = this.state;
    return (
      <>
        <div className="row moni-details">
          {this.props.loading ? (
            <div
              className="col-sm-12 bordercss"
              style={{ paddingBottom: "19px" }}
            >
              <div class="col-md-12 pageLoaderDetail">
                <span className="spinner spinner-dark "></span>
              </div>
            </div>
          ) : (
            <div className="col-sm-12 bordercss">
              {this.props.monitor &&
                this.props.monitor !== "undefined" &&
                (this.props.monitor.onlinestatus === "Online" ? (
                  <div className="color-box">
                    <img src={monitor_detail} alt="device_img"></img>
                    <p>Online</p>
                  </div>
                ) : (
                  <div className="color-box orange">
                    <img src={monitor_detail} alt="device_img"></img>
                    <p>offline</p>
                  </div>
                ))}
              <div className="details-box-wrap">
                <div className="details-box">
                  <p>Serial number</p>
                  <p>Manufactured</p>
                  <p>Last Connected Date</p>
                </div>
                <div className="details-box">
                  <p>
                    {" "}
                    {this.props.monitor !== null
                      ? this.props.monitor.cloud_id
                      : null}
                  </p>
                  <p>
                    {" "}
                    {this.props.monitor !== null
                      ? moment(this.props.monitor.created_date).format(
                          "MM-DD-YYYY"
                        )
                      : null}
                  </p>
                  <p>
                    {" "}
                    {this.props.monitor !== null &&
                    this.props.monitor.last_connected_date !== null
                      ? moment(this.props.monitor.last_connected_date).format(
                          "MM-DD-YYYY"
                        )
                      : "--"}
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="col-sm-12 bordercss">
            <div className="audio-box">
              <p>
                {" "}
                <MonitorO /> Audio Recordings
              </p>
            </div>
            <div className="btn-box">
              <p
                className="getnewaudio"
                id="getnewaudio"
                onClick={() => {
                  this.requestAudio();
                }}
              >
                <DownloadIcon />
                Get New Audio
                {this.state.downloadAudioloading && (
                  <span
                    className="ml-3 spinner spinner-dark"
                    style={{ marginRight: "20px" }}
                  ></span>
                )}
              </p>
              {this.state.requestAudioMsg !== null ? (
                <Snackbar
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  open={open}
                  onClose={this.handleClose}
                  autoHideDuration={6000}
                >
                  <MuiAlert
                    onClose={this.handleClose}
                    severity="error"
                    elevation={6}
                    variant="filled"
                    className="error"
                  >
                    {this.state.requestAudioMsg}
                  </MuiAlert>
                </Snackbar>
              ) : null}
            </div>
          </div>
          <div className="col-sm-12 dateRangePicker-div">
            <NewDateRange
              monitor={this.props.monitor}
              //ref={this.myRef}
            ></NewDateRange>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeMenu: Actions.changeSideBar,
      handleAudioGrid: Actions.handleAudioGrid,
    },
    dispatch
  );
}
function mapStateToProps(state) {
  return {
    selectedMenu: state.selectedMenu,
    isaudioGrid: state.isaudioGrid,
    refreshAudio: state.refreshAudio,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AudioFile);
